import { Navigate, useLocation } from 'react-router-dom';
import { Wind } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-teal-50 flex items-center justify-center">
        <div className="text-center">
          <Wind className="w-12 h-12 text-teal-500 mx-auto animate-pulse" />
          <p className="mt-4 text-stone-500">Chargement...</p>
        </div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;
